import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Template on notification_templates {
    id
    event_trigger
    delivery_type
    subject
    body
    recipient_role
    product_type  
  }
`;

export const GET_TEMPLATES = gql`
  query getTemplates($trigger: String, $role: String) {
    rows: notification_templates(
      where: {
        event_trigger: { _eq: $trigger }
        recipient_role: { _eq: $role }
      }
    ) {
      ...Template
    }
  }
  ${FRAGMENTS}
`;

export const UPSERT_TEMPLATE = gql`
  mutation upsert($data: notification_templates_insert_input!) {
    insert_notification_templates_one(
      object: $data
      on_conflict: {
        constraint: notification_templates_pkey
        update_columns: [body, subject, delivery_type, recipient_role, event_trigger, product_type]
      }
    ) {
      ...Template
    }
  }
  ${FRAGMENTS}
`;

export const COPY_TEMPLATES = gql`
  mutation upsert($data: [notification_templates_insert_input!]!) {
    insert_notification_templates(
      objects: $data
      on_conflict: {
        constraint: notification_templates_event_trigger_recipient_role_delivery_ty
        update_columns: [body, subject, delivery_type, event_trigger, recipient_role, product_type]
      }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_TEMPLATE = gql`
    mutation del($id:Int!) {
        delete_notification_templates_by_pk(id:$id) {
            id
        }
    }
`